export const removeHtmlSpaces = (value) => {
    if (typeof value === "string") {
        return value.replace(/&nbsp;/g, "\u00A0");
    }
    return value;
};

export const cleanHeadingsForSubmenu = (section) => {
    const cleaned = {
        ...section,
        heading: removeHtmlSpaces(section.heading),
    };

    if (Array.isArray(cleaned.contents)) {
        cleaned.contents = cleaned.contents.map((item) => {
            const cleanedItem = {
                ...item,
                heading: removeHtmlSpaces(item.heading),
            };

            if (Array.isArray(cleanedItem.contents)) {
                cleanedItem.contents = cleanedItem.contents.map((subItem) => ({
                    ...subItem,
                    heading: removeHtmlSpaces(subItem.heading),
                }));
            }

            return cleanedItem;
        });
    }

    return cleaned;
};

export const cleanHeadingsGallerySpeechListing = (section) => {
    const cleaned = {
        ...section,
        title: removeHtmlSpaces(section.title),
    };

    return cleaned;
};
